export enum FloridaLoadIdentity {
  billOfLading = 'billOfLading',
  equipmentVIN = 'equipmentVIN',
  loadId = 'loadId',
  trailerOrTruckUnit = 'trailerOrTruckUnit',
  truckOrTrailerTag = 'truckOrTrailerTag',
}

export const FloridaLoadIdentityValues = Object.values(FloridaLoadIdentity);
